import { Card, Box, Flex, Text, Button } from '@opendoor/bricks/core';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import { MarginProps } from '@opendoor/bricks/system/theme';
import React from 'react';
import { useOfferContext } from 'sellDirect/OfferContext';
/**
 * Renders the CTA for user to refresh the offer.
 * Desktop - renders a card with description and button CTA
 * Mobile - renders a button CTA
 * component-test-check-ignore
 */
export const RefreshOfferCta: React.FC<MarginProps> = (marginProps) => {
  const { shouldSeeAgentExperience, loading, refreshOffer, isRefreshingOffer } = useOfferContext();
  const { isMobile } = useDevice();
  const shouldDisableCta = isRefreshingOffer || loading;

  const ctaTextDesktop = shouldSeeAgentExperience
    ? 'Refresh my client’s offer'
    : 'Refresh my offer';

  const ctaTextMobile = `Next - ${ctaTextDesktop}`;

  const descriptionText = shouldSeeAgentExperience
    ? 'Next - Refresh your client’s offer'
    : 'Next - Refresh your offer';

  const handleClick = () => {
    refreshOffer();
  };

  if (isMobile) {
    return (
      <Box px={7} py={5} {...marginProps}>
        <Button
          data-testid="refresh-offer-cta"
          analyticsName="refresh-offer-cta"
          aria-label="refresh offer"
          type="button"
          onClick={handleClick}
          disabled={shouldDisableCta}
          loading={shouldDisableCta}
        >
          {ctaTextMobile}
        </Button>
      </Box>
    );
  }
  return (
    // p={[7, null, 7]} is necessary to overwrite the `Card` component default padding :(
    <Card variant="primary" width="100%" p={[7, null, 7]} {...marginProps}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text size="s2" fontWeight="semibold" color="neutrals100">
          {descriptionText}
        </Text>
        <Button
          data-testid="refresh-offer-cta"
          analyticsName="refresh-offer-cta"
          aria-label="refresh offer"
          type="button"
          onClick={handleClick}
          disabled={shouldDisableCta}
          loading={shouldDisableCta}
          width="264px"
        >
          {ctaTextDesktop}
        </Button>
      </Flex>
    </Card>
  );
};
